import { rootApi } from "../../api/rootApi";

export const adminAuthApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        adminLogin: builder.mutation({
            query: (body) => {
                console.log("auth login");
                return {
                    method: "POST",
                    url: "/admin/login",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body),
                };
            },
        }),
        logout: builder.mutation({
            query: ({ query, tenant_id, token }) => {
                return {
                    method: "GET",
                    url: `/admin/logout/?${new URLSearchParams(query).toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        slug: tenant_id || "",
                        Authorization: `Bearer ${token}`
                    },
                };
            },
        }),
    }),
});

export const { useAdminLoginMutation, useLogoutMutation } = adminAuthApi;
